import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { TOKEN_KEY } from "../lib/apiClient";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem(TOKEN_KEY, res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-slate-300">
        <Loader2 className="h-10 w-10 animate-spin text-indigo-400" />
        <p className="font-display text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
